import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import BASE_URL from "../constants/baseUrls";
import { saveIntFlightData, saveTicketSelectedFilters } from "../store/actions";
import { useEffect, useRef } from "react";
import { scrollToPosition } from "../utils/utility";

const useIntFlightList = (intFlightInformation, uid, page, ticketSort, ticketSelectedFilters, setRequestFlag, setLoading, setIsError) => {
    //general variables
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");
    const ticketType = intFlightInformation?.returnDate ? "return" : "onWay";
    const isMountedRef = useRef(true);
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation"));

    const getFlightList = async () => {
        scrollToPosition(0, 0);
        try {
            setLoading(true);
            setIsError(false);
            const data = {
                sort: ticketSort,
                price_from: ticketSelectedFilters?.prices?.[0],
                price_to: ticketSelectedFilters?.prices?.[1],
                departure_time_from: ticketSelectedFilters?.departure_times?.[0],
                departure_time_to: ticketSelectedFilters?.departure_times?.[1],
                return_departure_time_from: ticketSelectedFilters?.return_departure_times?.[0],
                return_departure_time_to: ticketSelectedFilters?.return_departure_times?.[1],
                flight_duration_from: ticketSelectedFilters?.flight_durations?.[0],
                flight_duration_to: ticketSelectedFilters?.flight_durations?.[1],
                return_flight_duration_from: ticketSelectedFilters?.return_flight_durations?.[0],
                return_flight_duration_to: ticketSelectedFilters?.return_flight_durations?.[1],
                airlines: ticketSelectedFilters?.airlines,
                return_airlines: ticketSelectedFilters?.return_airlines,
                airports: ticketSelectedFilters?.airports,
                return_airports: ticketSelectedFilters?.return_airports,
                baggages: ticketSelectedFilters?.baggages,
                return_baggages: ticketSelectedFilters?.return_baggages,
                arrival_time_from: ticketSelectedFilters?.arrival_times?.[0],
                arrival_time_to: ticketSelectedFilters?.arrival_times?.[1],
                return_arrival_time_from: ticketSelectedFilters?.return_arrival_times?.[0],
                return_arrival_time_to: ticketSelectedFilters?.return_arrival_times?.[1],
                flight_stops: ticketSelectedFilters?.flight_stops,
                return_flight_stops: ticketSelectedFilters?.return_flight_stops,
            };
            const response = await axios.post(`${BASE_URL}/api/v2/reserve/foreign/flight/list/`, data, {
                params: {
                    date: intFlightInformation?.departureDate,
                    departure:isItinerary? intFlightInformation?.departure?.iata : intFlightInformation?.departure?.id,
                    destination:isItinerary? intFlightInformation?.destination?.iata : intFlightInformation?.destination?.id,
                    round_trip: ticketType === "return" ? true : false,
                    adult: intFlightInformation?.personCounter?.adult,
                    child: intFlightInformation?.personCounter?.child,
                    infant: intFlightInformation?.personCounter?.infant,
                    return_date: ticketType === "return" ? intFlightInformation?.returnDate : intFlightInformation?.departureDate,
                    uid: uid,
                    page: page,
                    cabin_type: intFlightInformation?.cabinType?.value,
                    direct_flight: intFlightInformation?.isDirect,
                },
                headers: {
                    Authorization: accessToken ? `Bearer ${accessToken}` : "",
                },
            });
            if (isMountedRef.current) {
                dispatch(saveIntFlightData(response.data?.data));
            }
        } catch (error) {
            if (isMountedRef.current) {
                toast.error(t("errorMessage"), { toastId: "custom-id-yes" });
                dispatch(saveIntFlightData(null));
                dispatch(saveTicketSelectedFilters(null));
                setIsError(true);
            }
        } finally {
            if (isMountedRef.current) {
                setLoading(false);
                setRequestFlag(false);
                searchParams.delete("action");
                setSearchParams(searchParams);
            }
        }
    };

    // Clean up on unmount
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    return { getFlightList };
};

export default useIntFlightList;
